<div class="flex items-center justify-center dialog-header ">
    Add New Task

    <div class="absolute right-2">
        <button
            (click)="handleClosDialog()"
            class="outline-none p-5"
        >
            <i class="pi pi-times"></i>
        </button>
    </div>

</div>
<div class="dialog-content">
    <div class="">
        <div class="mb-2 font-medium">Enter Lead Task</div>
        <textarea rows="5" cols="30"
        class="w-full "
        pTextarea [(ngModel)]="leadTask"></textarea>
    </div>
    <div class="flex justify-end  mt-4">
        <p-button
            label="Add Task"
            [loading]="loading"
            [disabled]="!leadTask || loading"
            icon="pi pi-save"
            class="flex justify-end"
            (click)="handleSaveTask()"
        ></p-button>
    </div>
</div>